import React from 'react';
import LoginComponent from '../../components/Layout/Login/Login';

const Login = (): JSX.Element => {
    return <LoginComponent />;
};

export default Login;
